import React from "react";
import { ArrowRight, LayoutGrid, Target, Building2 } from "lucide-react";
import { openAgent } from "../../utils/openAgent";
import AnimatedEnergyOverlay from "./AnimatedEnergyOverlay";

// 3 tabs matching Figma
const TABS = [
  { name: "Business Function", icon: LayoutGrid },
  { name: "Business Objective", icon: Target },
  { name: "Industries", icon: Building2 },
];

export const OppHero = () => {
  return (
  <section className="relative flex min-h-[100dvh] w-full items-center overflow-hidden" style={{ background: "#010710" }}>
    
    {/* top-left glow */}
    <div className="pointer-events-none absolute" style={{ width: 1187, height: 345, left: -238, top: -89, background: "#173862", filter: "blur(92.65px)" }} />
    
    <div className="relative mx-auto w-full max-w-[1440px] px-6 py-24 lg:px-[70px]">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8 xl:gap-0">
        
        {/* Left copy - Spans 5 columns */}
        <div className="relative z-10 flex w-full flex-col gap-[24px] lg:col-span-5">
          <div className="flex flex-col gap-[45px]">
            <div className="flex flex-col gap-[24px]">
              <p className="text-[11px] font-bold uppercase leading-[16.5px] tracking-[2.2px] text-white/80">
                EXPLORE. DISCOVER. CREATE VALUE.
              </p>
              <h1 className="text-[38px] font-bold leading-[1.15] text-white sm:text-[46px] lg:text-[54px] lg:leading-[65px] xl:text-[64px] xl:leading-[72px]">
                Where could AI create value in
                <br />
                <span style={{ color: "#05D6DA" }}>your business?</span>
              </h1>
            </div>
            <p className="max-w-[556px] text-[18px] font-normal leading-[29.25px] text-white/80">
              Explore real opportunities across every function. See what’s possible, get inspired and discover what’s most relevant for you.
            </p>
          </div>
          
          <div className="flex flex-wrap items-center gap-5 pt-4">
            <button
              onClick={openAgent}
              className="flex items-center gap-2 rounded-full bg-white px-6 py-[14px] text-[15px] font-medium text-black transition-transform duration-200 hover:scale-[1.03]"
              style={{ boxShadow: "0px 4px 24px rgba(47,115,246,0.73)" }}
            >
              Discover Your AI Opportunities <ArrowRight className="h-4 w-4" strokeWidth={2} />
            </button>
          </div>
        </div>
        
        {/* Right image - Spans 7 columns */}
        <div className="relative mx-auto w-full lg:col-span-7 lg:ml-auto lg:translate-x-12 xl:translate-x-20 xl:scale-[1.15]">
          <div className="relative w-full max-w-[1100px]">
            <img src="/images/opportunities/hero.png" alt="Where AI creates value" className="w-full object-contain block" />
            <AnimatedEnergyOverlay />
          </div>
        </div>
        
      </div>
    </div>
  </section>
);
};

export const FilterBar = ({ active, setActive }) => (
  <section id="explore-opportunities-by" className="w-full bg-[#F8FAFC] border-t border-[#E2E8F0]/80 pt-10 pb-4 scroll-mt-[85px]">
    <div className="mx-auto flex max-w-[1360px] flex-wrap items-center gap-3 px-6 lg:px-8">
      <span className="pr-3 text-[14px] font-bold text-[#94A3B8]">Explore Opportunities By</span>
      {TABS.map(({ name, icon: Icon }) => {
        const isActive = active === name;
        return (
          <button
            key={name}
            onClick={() => setActive(name)}
            className={`flex items-center gap-2.5 rounded-full px-5 py-2 text-[14px] font-medium transition-all cursor-pointer ${
              isActive
                ? "bg-[#0B132B] text-white shadow-sm"
                : "border border-[#E2E8F0] bg-white text-[#334155] hover:border-[#CBD5E1] hover:bg-slate-50"
            }`}
          >
            <Icon className="h-4 w-4" strokeWidth={1.8} />
            {name}
          </button>
        );
      })}
    </div>
  </section>
);
